import { GlossaryEntryDto, UserProfileDto, UserRole } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { glossaryApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const DOMAIN_GLOSSARY = "GLOSSARY";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getAllGlossary = async (): Promise<GlossaryEntryDto[]> => {
  const response = await glossaryApi.glossaryControllerGetAllGlossaryTerms();

  return response.data;
};

export const useGetGlossary = (
  user: UserProfileDto | null,
): {
  glossary: GlossaryEntryDto[] | undefined;
  glossaryEnabled: boolean;
  isPendingGlossary: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isPending } = useQuery({
    queryKey: [DOMAIN_GLOSSARY],
    queryFn: getAllGlossary,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return { glossary: data, glossaryEnabled: enabled, isPendingGlossary: isPending };
};
